import { render } from "./OrigenDestinosIndex.vue?vue&type=template&id=18436028"
import script from "./OrigenDestinosIndex.vue?vue&type=script&lang=js"
export * from "./OrigenDestinosIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/cruds/OrigenDestinosIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18436028"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18436028', __exports__)) {
    api.reload('18436028', __exports__)
  }
  
  module.hot.accept("./OrigenDestinosIndex.vue?vue&type=template&id=18436028", () => {
    api.rerender('18436028', render)
  })

}


export default __exports__